// docs: https://github.com/altostra/type-validations#readme
import { anyOf, enumOf, objectOf, maybe } from "@altostra/type-validations";
import { string, boolean, number, any, nullValidation } from "@altostra/type-validations/lib/primitives";

import { isSurveyDefinition } from "@lib/surveys";

const nullableString = anyOf(string, nullValidation);

const isLandingPageDraftContent = objectOf({
  name: maybe(string, true),
  description: maybe(nullableString, true),
  slug: maybe(string, true),
  site_name: maybe(string, true),
  site_description: maybe(nullableString, true),
  favicon_url: maybe(nullableString, true),
  favicon_url_is_custom: maybe(boolean, true),
  grapes_js_data: maybe(any, true),
  html: maybe(string, true),
  survey_definition: maybe(any, true),
});

export const isEngagementLandingPageDataResult = objectOf({
  id: string,
  landing_page_id: string,
  name: string,
  description: string,
  marked_as_deleted: boolean,
  enabled: boolean,
  last_edited: number,
  last_edited_by: string,
  unpublished_timestamp: maybe(number, true),
  created_by: string,
  status: string,
  site_name: string,
  site_description: string,
  slug: string,
  favicon_url: string,
  favicon_url_is_custom: boolean,
  grapes_js_data: maybe(any, true),
  base_url: string,
  full_url: string,
  html: string,
  has_been_enabled: boolean,
  first_published: maybe(number, true),
  created_at: number,
  size_limit_status: maybe(enumOf("ok", "blocked", "warned"), true),
  size_limit_status_updated_at: maybe(number, true),
  survey_definition: maybe(isSurveyDefinition, true),
  has_post_launch_draft: maybe(boolean, true),
  post_launch_draft_id: maybe(anyOf(string, nullValidation), true),
  post_launch_draft_updated_at: maybe(number, true),
  draft_content: maybe(isLandingPageDraftContent, true),
});
